
import { defineComponent, ref, computed, onBeforeMount } from "vue";
import { useRoute, useRouter } from "vue-router";
import ApiService from "@/core/services/ApiService";
import Multiselect from "@vueform/multiselect";
import store from "@/store";
import { Actions } from "@/store/enums/StoreEnums";
import moment from "moment";
import Loading from "vue-loading-overlay";
import CurrencyInput from "vue-currency-input";
import { useToast } from "vue-toastification";
import "vue-loading-overlay/dist/vue-loading.css";

export default defineComponent({
  name: "MasterInvoiceForm",
  components: {
    Multiselect,
    CurrencyInput,
    Loading,
  },
  watch: {
    dueDate: function (newVal) {
      if (newVal < 0) {
        this.dueDate = 0; // Reset to 0 if negative
      }
    },
    addData: function (newVal) {
      if (newVal.quantity < 0) this.addData.quantity = 0;
      if (newVal.amount < 0) this.addData.amount = 0;
    },

    invoiceType: function (newVal) {
      this.getSetting(newVal);
    },
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const id = ref(route.params.id);
    const invoices = ref<any[]>([]);
    const invoiceSettingList = ref<any[]>([]);
    const searchQuery = ref("");
    const filterStatus = ref("");
    const invoiceType = ref("");
    const title = ref("");
    const schoolId = ref<any[]>([]); // Explicitly type as string array
    const paymentStatus = ref(""); // Assuming you have a way to set this
    const isLoading = ref(false);
    const schoolSelected = ref(false);
    const schoolName = ref<any[]>([]);
    const ListSchool = ref<any[]>([]);
    const loadingComboSchool = ref(false);
    const timerComboSchool = ref(0);
    const role = ref("");
    const type = ref("");
    const isNameAutoGenerated = ref(false);
    const repeatType = ref();
    const invoiceDate = ref<any>("");
    const invoiceMonth = ref<any>("");
    const dueDate = ref<any>(0);
    const startInvoice = ref("");
    const endInvoice = ref("");
    const urlImage = ref("");
    const targetDataImage = ref<any>(null);
    const tax = ref(0);
    const isPublished = ref(false);
    const firstFetch = ref(true);
    const openListSchool = ref(false);
    const addData = ref<any>({
      name: "",
      amount: null,
      quantity: null,
      totalAmount: null,
    });
    const subTotal = computed(() => {
      let total = invoices.value.reduce((total, invoice) => {
        return total + invoice.totalAmount;
      }, 0);
      return total;
    });
    const taxAmount = computed(() => {
      let total=0;
      if (tax.value == 12) {
        let dpp = subTotal.value * (11 / 12);
        total = dpp * 0.12;
      } else total = subTotal.value * tax.value/100;
      return Math.ceil(total);
    });
    const totalAmount = computed(() => {
      return subTotal.value + taxAmount.value;
    });

    const cancelInvoice = () => {
      router.back();
    };

    const publishInvoice = () => {
      isPublished.value = true;
      saveInvoice();
    };

    const handleDateMonth =(val)=>{
      // console.log(typeof val,val)
      if(val<10) return `0${val}`
      return val
    }

    const saveInvoice = async () => {
      const toast = useToast();
      let msg = "";
      try {
        let invoiceSetting: any = {
          invoiceType: type.value,
          invoiceDate: invoiceDate.value + "T00:00:00.000Z",
          dueDate: dueDate.value + "T23:59:59.000Z",
        };
        if (type.value == "BERULANG") {
          invoiceSetting.isNameAutoGenerated = isNameAutoGenerated.value;
          invoiceSetting.repeatType = repeatType.value;
          invoiceSetting.invoiceDate = handleDateMonth(invoiceDate.value)
          invoiceSetting.dueDate = dueDate.value;
          if (repeatType.value == "TAHUNAN")
            invoiceSetting.invoiceDate = `${handleDateMonth(invoiceMonth.value)}-${handleDateMonth(invoiceDate.value)}`;
          invoiceSetting.startInvoice = startInvoice.value + "T00:00:00.000Z";
          invoiceSetting.endInvoice = endInvoice.value + "T23:59:59.000Z";
        }
        let newData = {
          schoolIds: schoolId.value,
          invoiceSettingId: invoiceType.value,
          title: title.value,
          invoiceSetting: { ...invoiceSetting },
          attachment: "",
          invoices: invoices.value,
          subTotal: subTotal.value,
          tax: tax.value,
          totalAmount: totalAmount.value,
          isPublished: isPublished.value,
        };
        // return console.log(newData, 'newdata')
        let formData = new FormData();
        isLoading.value = true;
        if (targetDataImage.value) {
          formData.append("file", targetDataImage.value);
        }
        let url = ``;
        if (role.value == "SUPER_ADMIN")
          url = `crmv2/main_invoice/invoice/office/invoice/master`;
        if (id.value) {
          msg = "Update";
          if (targetDataImage.value) {
            let resImage = await ApiService.postWithData(
              `crmv2/main_image/image/upload/${id.value}`,
              formData
            );
            newData.attachment = resImage.data.imgUrl;
          }
          url = `${url}/update/${id.value}`;
          await ApiService.putWithData(`${url}`, newData);
          toast.success(`Berhasil ${msg} Data`);
        }

        if (!id.value) {
          msg = "Simpan";
          let urlCreate = `${url}/create`;
          let response = await ApiService.postWithData(`${urlCreate}`, newData);

          if (targetDataImage.value) {
            let resImage = await ApiService.postWithData(
              `crmv2/main_image/image/upload/${response.data._id}`,
              formData
            );
            newData.attachment = resImage.data.imgUrl;
            await ApiService.putWithData(
              `${url}/update/${response.data._id}`,
              newData
            );
          }
          toast.success(`Berhasil ${msg} Data`);
        }
        router.push("/superadmin/master-invoices");
      } catch (error: any) {
        console.log(error)
        toast.error(
          `Gagal ${msg} Data: ${error?.response?.data?.detail || error?.response?.data?.message
          }`
        );
      } finally {
        isLoading.value = false;
      }
    };

    const onlyNumber = (evt) => {
      let ASCIICode = evt.which ? evt.which : evt.keyCode;
      if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57))
        return evt.preventDefault();
      return true;
    };

    const fetchInvoices = async () => {
      try {
        isLoading.value = true;
        const response = await ApiService.getWithoutSlug(
          `crmv2/main_invoice/invoice/office/invoice/master/get/${route.params.id}`
        );
        title.value = response.data.title;
        schoolId.value = response.data.schoolIds;
        schoolName.value = response.data.schoolNames;
        openListSchool.value = true;
        invoices.value = response.data.invoices;
        invoiceType.value = response.data.invoiceSettingId;
        isPublished.value = response.data.isPublished;
        getSetting(response.data.invoiceSettingId);
        if (response.data.invoiceSetting)
          handleInvoiceSetting(response.data.invoiceSetting);
        if (response.data.attachment) {
          let resImage = await ApiService.getWithoutSlug(
            "crmv2/main_image/image/get/base64/" + response.data.attachment
          );
          urlImage.value = "data:image/jpg;base64," + resImage.data;
        }
      } catch (error: any) {
        console.error(
          "Error fetching invoices:",
          error.response.data.detail || error.response.data.message
        );
      } finally {
        isLoading.value = false;
      }
    };

    const handleInvoiceSetting = (setting) => {
      type.value = setting.invoiceType;
      if (setting.invoiceType == "SEKALI") {
        invoiceDate.value = formatDate(setting.invoiceDate);
        dueDate.value = formatDate(setting.dueDate);
      }
      if (setting.invoiceType == "BERULANG") {
        invoiceDate.value = parseInt(setting.invoiceDate);
        if (setting.repeatType == "TAHUNAN") {
          let monthdate = setting.invoiceDate.split("-");
          invoiceMonth.value = parseInt(monthdate[0]);
          invoiceDate.value = parseInt(monthdate[1]);
        }
        isNameAutoGenerated.value = setting.isNameAutoGenerated;
        repeatType.value = setting.repeatType;
        dueDate.value = setting.dueDate;
        startInvoice.value = formatDate(setting.startInvoice);
        endInvoice.value = formatDate(setting.endInvoice);
        firstFetch.value = false;
      }
    };
    const formatPrice = (value) => {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };

    const formatDate = (val) => {
      if (val) return moment(val).format("YYYY-MM-DD");
      else return "";
    };

    const pilihInvoiceType = (event) => {
      invoiceType.value = event;
      getSetting(event);
    };

    const getSetting = async (id = "") => {
      tax.value = 0;
      try {
        const response = await ApiService.getWithoutSlug(
          `crmv2/main_invoice/invoice/office/invoice/settings/${id}`
        );
        tax.value = response.data.tax;
      } catch (error) { }
    };

    const navigateToAddInvoice = () => {
      router.push({ path: "/superadmin/master-invoices/add" });
    };

    const editInvoice = (id) => {
      router.push({ path: `/superadmin/master-invoices/edit/${id}` });
    };

    const deleteInvoice = (index) => {
      invoices.value.splice(index, 1);
    };

    const addDetailInvoice = () => {
      let newData = {
        ...addData.value,
        totalAmount: addData.value.amount * addData.value.quantity,
      };
      invoices.value.push(newData);
      addData.value = {
        name: "",
        amount: null,
        quantity: null,
        totalAmount: null,
      };
    };

    const pilihSekolah = (event) => {
      schoolId.value = [];
      schoolSelected.value = false;
      if (event) {
        let school: any = ListSchool.value.filter((item: any) =>
          event.includes(item.id)
        );
        schoolId.value = event;
        schoolSelected.value = true;
        schoolName.value = school.map((item: any) => item.name);
      }
    };

    const cari = (val) => {
      clearTimeout(timerComboSchool.value); //this timer 0 - set 0 atau clear jika ada input lagi
      loadingComboSchool.value = true;
      timerComboSchool.value = setTimeout(() => {
        getListSchool(val);
      }, 1000);
    };

    const getListSchool = async (name = "") => {
      let list = JSON.parse(localStorage.getItem("listSchool")!);
      if (list && list.length > 0) {
        ListSchool.value = list;
        return;
      }
      loadingComboSchool.value = true;
      ApiService.getWithoutSlug(
        `crmv2/main_invoice/invoice/office/invoice/combo/school?name=${name}&limit=2000`
      ).then(({ data }) => {
        loadingComboSchool.value = false;
        ListSchool.value = data;
        localStorage.setItem("listSchool", JSON.stringify(data));
      });
    };

    const getListInvoiceSetting = () => {
      ApiService.getWithoutSlug(
        `crmv2/main_invoice/invoice/office/invoice/settings/combo_inv_setting`
      ).then(({ data }) => {
        invoiceSettingList.value = data;
      });
    };

    const handleFileUpload = (event) => {
      urlImage.value = URL.createObjectURL(event.target.files[0]);
      targetDataImage.value = event.target.files[0];
    };

    onBeforeMount(async () => {
      store.dispatch(Actions.VERIFY_AUTH_FINANCE);
      role.value = JSON.parse(localStorage.getItem("user_account")!).role;
      await getListSchool();
      if (route.params.id) fetchInvoices();
      getListInvoiceSetting();
    });

    return {
      Multiselect,
      id,
      title,
      invoices,
      searchQuery,
      filterStatus,
      formatPrice,
      schoolId,
      paymentStatus,
      isLoading,
      schoolSelected,
      schoolName,
      ListSchool,
      loadingComboSchool,
      invoiceType,
      type,
      isNameAutoGenerated,
      repeatType,
      invoiceDate,
      invoiceMonth,
      dueDate,
      startInvoice,
      endInvoice,
      urlImage,
      invoiceSettingList,
      tax,
      subTotal,
      taxAmount,
      totalAmount,
      addData,
      isPublished,
      targetDataImage,
      firstFetch,
      moment,
      openListSchool,
      handleFileUpload,
      fetchInvoices,
      navigateToAddInvoice,
      editInvoice,
      deleteInvoice,
      pilihSekolah,
      pilihInvoiceType,
      cari,
      addDetailInvoice,
      getSetting,
      saveInvoice,
      publishInvoice,
      cancelInvoice,
      onlyNumber,
    };
  },
});
